//@flow

import React from "react";

interface cellExpandRendererProps {
  tabIndex: number;
  row: {
    id: number,
    name: string,
    level: number,
    isExpanded: boolean,
    hasChildren: boolean,
    ancessors: [number],
  };
  onCellExpand: () => void;
}

export default function cellExpandRenderer(props: cellExpandRendererProps) {
  return (
    <div
      className={`${props.row.hasChildren ? "cursor-pointer" : ""}`}
      style={{ paddingLeft: `${props.row.level * 20}px` }}
      onClick={props.row.hasChildren ? props.onCellExpand : null}
    >
      <span
        style={{ top: "3px", opacity: props.row.hasChildren ? 1 : 0 }}
        className={`material-icons position-relative  fs-18 ${
          props.row.isExpanded ? "transform-rotate-90" : "transform-rotate-0"
        }`}
        tabIndex={props.tabIndex}
      >
        chevron_right
      </span>
      <span>{props.row.name}</span>
    </div>
  );
}
